module.exports = __webpack_public_path__ + "static/media/content4.ca3e4084.jpg";